import { Link } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import { useLocale } from '../../shared/i18n/LocaleContext'
import type { MenuItem } from '../../shared/navigation/menu'
import { useNavigationPreferences } from './NavigationPreferencesContext'

export function HomePage() {
  const { user } = useAuth()
  const { t } = useLocale()
  const preferences = useNavigationPreferences()
  return <main className="page-content home-page">
    <section className="welcome home-welcome">
      <div><span className="eyebrow">{t('home.eyebrow')}</span>
        <h1>{t('home.welcome')}, {user?.displayName}</h1><p>{t('home.subtitle')}</p></div>
    </section>
    {preferences.error && <div className="error-banner">{t(preferences.error as 'home.loadError')}</div>}
    <HomeSection title={t('home.favorites')} description={t('home.favoritesDescription')}
      empty={t('home.noFavorites')} items={preferences.favorites} removable />
    <HomeSection title={t('home.recent')} description={t('home.recentDescription')}
      empty={t('home.noRecent')} items={preferences.recent} />
  </main>
}

function HomeSection({ title, description, empty, items, removable = false }:
  { title: string; description: string; empty: string; items: MenuItem[]; removable?: boolean }) {
  const { t } = useLocale()
  const { isLoading, toggleFavorite } = useNavigationPreferences()
  return <section className="home-section" aria-label={title}>
    <div className="section-heading"><div><h2>{title}</h2><p>{description}</p></div></div>
    {isLoading ? <div className="home-empty">{t('home.loading')}</div> : items.length === 0
      ? <div className="home-empty">{empty}</div>
      : <div className="home-card-grid">{items.map(item => <article className="home-card" key={item.key}>
          <Link to={item.route}><span className="home-card-icon" aria-hidden="true">{item.icon ?? '↗'}</span>
            <span><strong>{t(item.labelKey)}</strong><small>{item.moduleLabelKey ? t(item.moduleLabelKey) : t('home.openScreen')}</small></span><span aria-hidden="true">→</span></Link>
          {removable && <button type="button" className="home-remove-favorite"
            aria-label={`${t('home.removeFavorite')}: ${t(item.labelKey)}`}
            title={t('home.removeFavorite')} onClick={() => void toggleFavorite(item)}>★</button>}
        </article>)}</div>}
  </section>
}
